const getPayload = (filters) => {
    let propertyPost = {};
    filters.forEach(item => {
        propertyPost[item.propertyPost] = item.value;
        return propertyPost;
    });
    return propertyPost;
};

export default getPayload;